<aside class="sidebar" [class.experimental-panel-open]="experimentalFeaturesPanelOpen" [class.notify-panel-open]="notifyBroadcastPanelOpen">
  <!-- Logo -->
  <div class="sidebar-logo">
    <button type="button" class="logo-link" (click)="navigate('/home')">
      <img src="logo.png" [alt]="'sidebar.logoAlt' | translate" class="logo-image">
    </button>
  </div>

  <!-- Entity Selector (Top Box) -->
  <div class="entity-selector-box" *ngIf="currentUser">
    <button type="button"
            class="entity-selector-btn"
            #entitySelectorBtn
            [class.keyboard-active]="entitySelectorActive && !dcrDropdownOpen"
            [attr.aria-expanded]="dcrDropdownOpen"
            [disabled]="dcrPickerDisabled || (entitySyncPending$ | async)"
            (click)="toggleDcrList($event)">
      <svg class="entity-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101.15 122.88">
        <path d="M18,27.19c8.26,2.76,19.76,4.46,32.53,4.46S74.83,30,83.09,27.19c7.25-2.42,11.73-5.35,11.73-8.22s-4.48-5.79-11.73-8.21C74.83,8,63.33,6.29,50.56,6.29S26.29,8,18,10.76C2.65,15.89,2.22,21.91,18,27.19Zm62,70.5a5,5,0,1,1-4.94,5,4.94,4.94,0,0,1,4.94-5Zm0-28a4.95,4.95,0,1,1-4.94,5,4.94,4.94,0,0,1,4.94-5Zm0-29.13a4.95,4.95,0,1,1-4.94,4.95A4.94,4.94,0,0,1,80,40.59Zm14.8,45a39.45,39.45,0,0,1-9.76,4.62C76.18,93.18,64,95,50.56,95S24.94,93.18,16,90.21a39.87,39.87,0,0,1-9.68-4.55V104.5c.57,2.68,4.92,5.37,11.67,7.62,8.26,2.76,19.76,4.47,32.53,4.47s24.27-1.71,32.53-4.47c5-1.67,8.69-3.58,10.49-5.55,1.49-1.63,1.26-2.7,1.26-4.64V85.59ZM0,19C0,13.1,6.13,8.12,16,4.81,24.94,1.84,37.15,0,50.56,0S76.18,1.84,85.08,4.81,100,12.22,101,17.41a3.11,3.11,0,0,1,.18,1.06v86.74c0,6-11.49,11.33-16.07,12.86-8.9,3-21.11,4.81-34.52,4.81S24.94,121,16,118.07c-4.69-1.56-16-6.71-16-12.86v-2Q.07,61.09,0,19ZM6.36,76.64C6.93,79.32,11.28,82,18,84.26c8.26,2.76,19.76,4.47,32.53,4.47S74.83,87,83.09,84.26c7.25-2.42,11.73-5.35,11.73-8.21h0V57.73a39.79,39.79,0,0,1-9.78,4.62c-8.9,3-21.11,4.81-34.52,4.81S24.94,65.32,16,62.35A39.87,39.87,0,0,1,6.36,57.8V76.64Zm0-27.86c.57,2.68,4.92,5.37,11.67,7.62,8.26,2.76,19.76,4.47,32.53,4.47s24.27-1.71,32.53-4.47c7.25-2.42,11.73-5.35,11.73-8.21h0V28.52a40.15,40.15,0,0,1-9.78,4.62C76.18,36.11,64,38,50.56,38S24.94,36.11,16,33.14a39.87,39.87,0,0,1-9.68-4.56v20.2Z"/>
      </svg>
      <span class="entity-name">{{ getSelectedEntityName() }}</span>
      <svg *ngIf="isActiveDcrSandbox" class="sandbox-icon sandbox-icon--active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" title="Sandbox">
        <title>Sandbox</title>
        <path d="M9 3h6M9 3v7L5 19a1 1 0 00.93 1.36h12.14A1 1 0 0019 19l-4-9V3"/>
        <path d="M8 13h8"/>
      </svg>
      <ng-container *ngIf="entitySyncPending$ | async; else chevronTpl">
        <span class="entity-sync-spinner" aria-hidden="true"></span>
      </ng-container>
      <ng-template #chevronTpl>
        <span class="chevron" [class.open]="dcrDropdownOpen">▾</span>
      </ng-template>
    </button>

    <!-- DCR Dropdown -->
    <div class="dcr-dropdown" *ngIf="dcrDropdownOpen" (click)="$event.stopPropagation()">
      <div class="dropdown-header">{{ 'sidebar.dcr.title' | translate }}</div>
      <div class="dcr-search">
        <input type="text"
               class="dcr-search-input"
               [placeholder]="'sidebar.dcr.searchPlaceholder' | translate"
               [value]="dcrSearchTerm"
               (input)="onDcrSearch($event)"
               (keydown)="onDcrKeydown($event)"
               autofocus>
        <i class="ti-search"></i>
      </div>
      <ul class="dcr-options" role="listbox" #dcrOptionsList>
        <!-- Global data scope entry: pinned at top, only for users with global data access -->
        <ng-container *ngIf="showGlobalScopeEntry">
          <li role="option"
              class="dcr-option-admin"
              [class.active]="isGlobalScopeSelected"
              [attr.aria-selected]="isGlobalScopeSelected"
              (click)="selectGlobalScope($event)">
            <span class="option-name">{{ 'sidebar.dcr.globalScope' | translate }}</span>
          </li>
          <li class="dcr-separator" aria-hidden="true"></li>
        </ng-container>
        <ng-container *ngFor="let dcr of filteredDcrs; let i = index; trackBy: trackDcr">
          <li *ngIf="isFirstNonVisionDcr(dcr, i)" class="dcr-separator" aria-hidden="true"></li>
          <li role="option"
              [attr.aria-selected]="activeDcrId === dcr.id"
              [attr.aria-disabled]="!canSelectDcr(dcr) || null"
              [class.active]="activeDcrId === dcr.id"
              [class.keyboard-focused]="keyboardFocusedIndex === i"
              [class.dcr-option-disabled]="!canSelectDcr(dcr)"
              [class.vision-allowed]="canDcrAccessVision(dcr)"
              (click)="selectDcr(dcr, $event)">
            <span class="option-name">{{ getDcrLabel(dcr) || ('Entity ' + dcr.id) }}</span>
            <svg *ngIf="dcr.isSandbox" class="sandbox-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" title="Sandbox">
              <title>Sandbox</title>
              <path d="M9 3h6M9 3v7L5 19a1 1 0 00.93 1.36h12.14A1 1 0 0019 19l-4-9V3"/>
              <path d="M8 13h8"/>
            </svg>
            <span class="vision-badge" *ngIf="hasGlobalDataAccess && canDcrAccessVision(dcr)">Vision</span>
          </li>
        </ng-container>
        <li class="dcr-empty" *ngIf="filteredDcrs.length === 0">
          {{ 'sidebar.dcr.empty' | translate }}
        </li>
      </ul>
    </div>
  </div>

  <!-- Product Selector Buttons (classic mode) -->
  <div class="product-selector-buttons" *ngIf="!accordionMenuEnabled">
    <button *ngIf="canAccessAnalyticsDashboard"
            type="button"
            class="product-btn"
            [class.active]="selectedProduct === 'dashboard'"
            (click)="selectProduct('dashboard', $event)">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="3" width="7" height="9" rx="1"></rect>
        <rect x="14" y="3" width="7" height="5" rx="1"></rect>
        <rect x="14" y="12" width="7" height="9" rx="1"></rect>
        <rect x="3" y="16" width="7" height="5" rx="1"></rect>
      </svg>
      <span>Analytics</span>
    </button>
    <button *ngIf="canAccessVision"
            type="button"
            class="product-btn"
            [class.active]="selectedProduct === 'vision'"
            [disabled]="!isVisionAvailable || (entitySyncPending$ | async)"
            (click)="selectProduct('vision', $event)">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
      <span>Vision</span>
    </button>
    <button *ngIf="isReachAvailable"
            type="button"
            class="product-btn"
            [class.active]="selectedProduct === 'reach'"
            (click)="selectProduct('reach', $event)">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="2" y1="12" x2="22" y2="12"></line>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
      </svg>
      <span>Reach</span>
    </button>
    <button *ngIf="canAccessTrackingScripts"
            type="button"
            class="product-btn"
            [class.active]="selectedProduct === 'tracking-scripts'"
            (click)="selectProduct('tracking-scripts', $event)">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="16 18 22 12 16 6"></polyline>
        <polyline points="8 6 2 12 8 18"></polyline>
      </svg>
      <span>Scripts</span>
    </button>
    <button *ngIf="canAccessCmp"
            type="button"
            class="product-btn"
            [class.active]="selectedProduct === 'cmp'"
            (click)="selectProduct('cmp', $event)">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <polyline points="9 15 11 17 15 13"></polyline>
      </svg>
      <span>CMP</span>
    </button>
  </div>

  <!-- Navigation Menu (Contextual based on product) -->
  <nav class="sidebar-nav">

    <!-- Accordion products menu (experimental feature) -->
    <div class="product-accordion experimental-marker" *ngIf="accordionMenuEnabled">
      <!-- Analytics (no sub-menu) -->
      <button *ngIf="canAccessAnalyticsDashboard"
              type="button"
              class="accordion-header"
              [class.active]="selectedProduct === 'dashboard'"
              (click)="selectProduct('dashboard', $event)">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="7" height="9" rx="1"></rect>
          <rect x="14" y="3" width="7" height="5" rx="1"></rect>
          <rect x="14" y="12" width="7" height="9" rx="1"></rect>
          <rect x="3" y="16" width="7" height="5" rx="1"></rect>
        </svg>
        <span>Analytics</span>
      </button>

      <!-- Vision -->
      <ng-container *ngIf="canAccessVision">
        <button type="button"
                class="accordion-header"
                [class.active]="selectedProduct === 'vision'"
                [class.open]="selectedProduct === 'vision' && !isOnHomePage && accordionExpanded"
                [disabled]="!isVisionAvailable || (entitySyncPending$ | async)"
                (click)="onAccordionHeaderClick('vision', $event)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
          </svg>
          <span>Vision</span>
          <span class="accordion-chevron" [class.open]="selectedProduct === 'vision' && !isOnHomePage && accordionExpanded">▾</span>
        </button>
        <div class="accordion-content" *ngIf="selectedProduct === 'vision' && !isOnHomePage && accordionExpanded">
          <ng-container [ngTemplateOutlet]="visionNavTpl"></ng-container>
        </div>
      </ng-container>

      <!-- Reach -->
      <ng-container *ngIf="isReachAvailable">
        <button type="button"
                class="accordion-header"
                [class.active]="selectedProduct === 'reach'"
                [class.open]="selectedProduct === 'reach' && !isOnHomePage && accordionExpanded"
                (click)="onAccordionHeaderClick('reach', $event)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="2" y1="12" x2="22" y2="12"></line>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
          </svg>
          <span>Reach</span>
          <span class="accordion-chevron" [class.open]="selectedProduct === 'reach' && !isOnHomePage && accordionExpanded">▾</span>
        </button>
        <div class="accordion-content" *ngIf="selectedProduct === 'reach' && !isOnHomePage && accordionExpanded">
          <ng-container [ngTemplateOutlet]="reachNavTpl"></ng-container>
        </div>
      </ng-container>

      <!-- Tracking Scripts -->
      <ng-container *ngIf="canAccessTrackingScripts">
        <button type="button"
                class="accordion-header"
                [class.active]="selectedProduct === 'tracking-scripts'"
                [class.open]="selectedProduct === 'tracking-scripts' && !isOnHomePage && accordionExpanded"
                (click)="onAccordionHeaderClick('tracking-scripts', $event)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="16 18 22 12 16 6"></polyline>
            <polyline points="8 6 2 12 8 18"></polyline>
          </svg>
          <span>Scripts</span>
          <span class="accordion-chevron" [class.open]="selectedProduct === 'tracking-scripts' && !isOnHomePage && accordionExpanded">▾</span>
        </button>
        <div class="accordion-content" *ngIf="selectedProduct === 'tracking-scripts' && !isOnHomePage && accordionExpanded">
          <ng-container [ngTemplateOutlet]="trackingScriptsNavTpl"></ng-container>
        </div>
      </ng-container>

      <!-- CMP -->
      <ng-container *ngIf="canAccessCmp">
        <button type="button"
                class="accordion-header"
                [class.active]="selectedProduct === 'cmp'"
                [class.open]="selectedProduct === 'cmp' && !isOnHomePage && accordionExpanded"
                (click)="onAccordionHeaderClick('cmp', $event)">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <polyline points="9 15 11 17 15 13"></polyline>
          </svg>
          <span>CMP</span>
          <span class="accordion-chevron" [class.open]="selectedProduct === 'cmp' && !isOnHomePage && accordionExpanded">▾</span>
        </button>
        <div class="accordion-content" *ngIf="selectedProduct === 'cmp' && !isOnHomePage && accordionExpanded">
          <ng-container [ngTemplateOutlet]="cmpNavTpl"></ng-container>
        </div>
      </ng-container>

    </div>

    <!-- Classic-mode contextual sub-nav (outlets to the shared templates below) -->
    <ng-container *ngIf="!accordionMenuEnabled">
      <ng-container *ngIf="selectedProduct === 'vision' && !isOnHomePage" [ngTemplateOutlet]="visionNavTpl"></ng-container>
      <ng-container *ngIf="selectedProduct === 'reach' && !isOnHomePage" [ngTemplateOutlet]="reachNavTpl"></ng-container>
      <ng-container *ngIf="selectedProduct === 'tracking-scripts' && !isOnHomePage" [ngTemplateOutlet]="trackingScriptsNavTpl"></ng-container>
      <ng-container *ngIf="selectedProduct === 'cmp' && !isOnHomePage" [ngTemplateOutlet]="cmpNavTpl"></ng-container>
    </ng-container>

    <!-- Vision Navigation (shared template: classic nav + accordion) -->
    <ng-template #visionNavTpl>
      <div class="nav-section" *ngIf="canAccessVision">
        <button class="nav-button"
                [class.active]="isActive('/vision/public')"
                (click)="navigate('/vision/public')">
          {{ 'sidebar.nav.public' | translate }}
        </button>
        <button class="nav-button"
                [class.active]="isActive('/vision/personas')"
                (click)="navigate('/vision/personas')">
          {{ 'sidebar.nav.personas' | translate }}
        </button>
        <button class="nav-button"
                [class.active]="isActive('/vision/comparison')"
                (click)="navigate('/vision/comparison')">
          {{ 'sidebar.nav.comparison' | translate }}
        </button>
      </div>

      <!-- Filters for Vision -->
      <div class="filters-section" *ngIf="showFilters">
        <h4 style="display: none;">
          {{ 'sidebar.filters.title' | translate }}
          <span class="reset-filters"
                *ngIf="hasActiveFilters"
                (click)="resetFilters($event)">{{ 'sidebar.filters.reset' | translate }}</span>
        </h4>
        <div class="filters-toggle" style="display: none;">
          <label class="toggle-control">
            <input type="checkbox"
                   [checked]="true"
                   (change)="onApplyFiltersToggle($event)">
            <span class="toggle-slider"></span>
          </label>
          <div class="toggle-copy">
            <span class="toggle-title">{{ 'sidebar.filters.toggleTitle' | translate }}</span>
            <span class="toggle-subtitle">{{ 'sidebar.filters.toggleSubtitle' | translate }}</span>
          </div>
        </div>

        <!-- Country Filter -->
        <div class="filter-group filter-disabled">
          <div class="filter-header" (click)="toggleFilter('country')">
            <label>{{ 'sidebar.filters.country.label' | translate }} ({{ selectedCountry }})</label>
            <span class="filter-arrow" [class.expanded]="expandedFilters['country']">▼</span>
          </div>
          <div class="filter-content" [class.expanded]="expandedFilters['country']">
            <div class="country-search">
              <input type="text"
                     class="country-search-input"
                     [placeholder]="'sidebar.filters.country.searchPlaceholder' | translate"
                     [value]="countrySearchTerm"
                     (input)="onCountrySearch($event)"
                     (click)="$event.stopPropagation()"
                     disabled>
            </div>
            <div class="country-list">
              <div *ngFor="let country of filteredCountries"
                   class="filter-option country-option"
                   [class.active]="selectedCountry === country"
                   (click)="selectCountry(country); $event.stopPropagation()">
                {{ country }}
              </div>
              <div class="country-empty" *ngIf="filteredCountries.length === 0">
                {{ 'sidebar.filters.country.noResults' | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- Date Range Filter -->
        <div class="filter-group" (click)="toggleFilter('dateRange')">
          <div class="filter-header">
            <label>{{ dateRangeLabel | translate }}</label>
            <span class="filter-arrow" [class.expanded]="expandedFilters['dateRange']">▼</span>
          </div>
          <div class="filter-content" [class.expanded]="expandedFilters['dateRange']">
            <div class="filter-option"
                 [class.active]="selectedDateRange === '7days'"
                 (click)="selectDateRange('7days'); $event.stopPropagation()">
              {{ 'sidebar.filters.dateRanges.7days' | translate }}
            </div>
            <div class="filter-option"
                 [class.active]="selectedDateRange === '14days'"
                 (click)="selectDateRange('14days'); $event.stopPropagation()">
              {{ 'sidebar.filters.dateRanges.14days' | translate }}
            </div>
            <div class="filter-option"
                 [class.active]="selectedDateRange === '30days'"
                 (click)="selectDateRange('30days'); $event.stopPropagation()">
              {{ 'sidebar.filters.dateRanges.30days' | translate }}
            </div>
            <div class="filter-option"
                 [class.active]="selectedDateRange === '90days'"
                 (click)="selectDateRange('90days'); $event.stopPropagation()">
              {{ 'sidebar.filters.dateRanges.90days' | translate }}
            </div>
          </div>
        </div>

        <!-- Device Filter -->
        <div class="filter-group">
          <div class="filter-header" (click)="toggleFilter('device')">
            <label>
              {{ 'sidebar.filters.device.label' | translate:{ selected: selectedDevices.length, total: availableDevices.length } }}
            </label>
            <span class="filter-arrow" [class.expanded]="expandedFilters['device']">▼</span>
          </div>
          <div class="filter-content" [class.expanded]="expandedFilters['device']">
            <div class="audience-list">
              <div *ngFor="let device of availableDevices" class="audience-filter-option">
                <label class="checkbox-label">
                  <input type="checkbox"
                         [checked]="device.selected"
                         (change)="toggleDevice(device.id)"
                         (click)="$event.stopPropagation()">
                  <span class="audience-name">{{ device.name }}</span>
                </label>
              </div>
            </div>
            <div class="selection-summary">
              {{ 'sidebar.filters.multiSelection' | translate }}
            </div>
          </div>
        </div>

        <!-- Traffic Source Filter -->
        <div class="filter-group">
          <div class="filter-header" (click)="toggleFilter('trafficSource')">
            <label>
              {{ 'sidebar.filters.traffic.label' | translate:{ selected: selectedTrafficSources.length, total: availableTrafficSources.length } }}
            </label>
            <span class="filter-arrow" [class.expanded]="expandedFilters['trafficSource']">▼</span>
          </div>
          <div class="filter-content" [class.expanded]="expandedFilters['trafficSource']">
            <div class="audience-list">
              <div *ngFor="let source of availableTrafficSources" class="audience-filter-option">
                <label class="checkbox-label">
                  <input type="checkbox"
                         [checked]="source.selected"
                         (change)="toggleTrafficSource(source.id)"
                         (click)="$event.stopPropagation()">
                  <span class="audience-name">{{ source.name }}</span>
                </label>
              </div>
            </div>
            <div class="selection-summary">
              {{ 'sidebar.filters.multiSelection' | translate }}
            </div>
          </div>
        </div>

        <!-- Audience Filter -->
        <div class="filter-group">
          <div class="filter-header" (click)="toggleFilter('audience')">
            <label>
              {{ 'sidebar.filters.audience.label' | translate:{ selected: selectedAudiences.length, total: availableAudiences.length } }}
            </label>
            <span class="filter-arrow" [class.expanded]="expandedFilters['audience']">▼</span>
          </div>
          <div class="filter-content" [class.expanded]="expandedFilters['audience']">
            <div class="audience-list">
              <div *ngFor="let audience of availableAudiences"
                   class="audience-filter-option"
                   [class.disabled]="isAudienceDisabled(audience.id)">
                <label class="checkbox-label">
                  <input type="checkbox"
                         [checked]="audience.selected"
                         (change)="toggleAudience(audience.id)"
                         [disabled]="isAudienceDisabled(audience.id)">
                  <span class="audience-name" [style.color]="audience.color">{{ audience.name }}</span>
                  <span class="audience-indicator" [style.background-color]="audience.color"></span>
                </label>
              </div>
            </div>
            <div class="selection-summary">
              {{ 'sidebar.filters.audience.summary' | translate:{ max: availableAudiences.length } }}
            </div>
          </div>
        </div>

        <!-- Goal Filter -->
        <div class="filter-group">
          <div class="filter-header" (click)="toggleFilter('goal')">
            <label>
              {{ 'sidebar.filters.goal.label' | translate }}
              ({{ selectedGoal?.name || ('sidebar.filters.goal.none' | translate) }})
            </label>
            <span class="filter-arrow" [class.expanded]="expandedFilters['goal']">▼</span>
          </div>
          <div class="filter-content" [class.expanded]="expandedFilters['goal']">
            <div class="audience-list">
              <div *ngFor="let goal of availableGoals" class="audience-filter-option">
                <label class="checkbox-label">
                  <input type="checkbox"
                         [checked]="goal.selected"
                         (change)="selectGoal(goal.id)"
                         (click)="$event.stopPropagation()">
                  <span class="audience-name">{{ goal.name }}</span>
                </label>
              </div>
            </div>
            <div class="selection-summary">
              {{ 'sidebar.filters.singleSelection' | translate }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Documentation TOC Navigation (shown in both modes) -->
    <ng-container *ngIf="isOnDocumentation">
      <div class="nav-section doc-toc">
        <li *ngFor="let item of docMenuItems$ | async"
            [class]="'nav-level-' + item.depth"
            (click)="scrollToSection(item.id)">
          {{ item.text }}
        </li>
      </div>
    </ng-container>

    <!-- Reach Navigation (shared template: classic nav + accordion) -->
    <ng-template #reachNavTpl>
      <div class="nav-section" *ngIf="canAccessAudience || canAccessAudienceTools">
        <button *ngIf="canAccessAudience"
                class="nav-button"
                [class.active]="isActive('/reach/audiences')"
                (click)="navigate('/reach/audiences')">
          {{ 'sidebar.nav.audience' | translate }}
        </button>
        <ng-container *ngIf="canAccessAudienceTools">
          <button class="nav-button"
                  [class.active]="isActive('/reach/custom-imports')"
                  (click)="navigate('/reach/custom-imports')">
            {{ 'sidebar.nav.customImports' | translate }}
          </button>
          <button class="nav-button"
                  *ngIf="canAccessDestinations"
                  [class.active]="isActive('/reach/destinations')"
                  (click)="navigate('/reach/destinations')">
            {{ 'sidebar.nav.destinations' | translate }}
          </button>
          <button class="nav-button"
                  [class.active]="isActive('/reach/goals')"
                  (click)="navigate('/reach/goals')">
            {{ 'sidebar.nav.goals' | translate }}
          </button>
          <ng-container *ngIf="canAccessReports">
            <button class="nav-button nav-button--parent"
                    [class.active]="isReportingActive"
                    [class.open]="reportingMenuOpen"
                    (click)="toggleReportingMenu()">
              <span>{{ 'sidebar.nav.reporting' | translate }}</span>
              <span class="nav-button__chevron" [class.open]="reportingMenuOpen">▾</span>
            </button>
            <div class="nav-submenu" *ngIf="reportingMenuOpen">
              <button class="nav-button nav-button--sub"
                      [class.active]="isActive('/reach/reports/consumer')"
                      (click)="navigate('/reach/reports/consumer')">
                {{ 'sidebar.nav.reportsConsumer' | translate }}
              </button>
              <button class="nav-button nav-button--sub"
                      [class.active]="isActive('/reach/reports/provider')"
                      (click)="navigate('/reach/reports/provider')">
                {{ 'sidebar.nav.reportsProvider' | translate }}
              </button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>

    <!-- Tracking Scripts Navigation (shared template: classic nav + accordion) -->
    <ng-template #trackingScriptsNavTpl>
      <div class="nav-section" *ngIf="canAccessTrackingScripts">
        <button class="nav-button"
                [class.active]="isActive('/tracking-scripts/configs')"
                (click)="navigate('/tracking-scripts/configs')">
          {{ 'sidebar.nav.trackingScripts' | translate }}
        </button>
      </div>
    </ng-template>

    <!-- CMP Navigation (shared template: classic nav + accordion) -->
    <ng-template #cmpNavTpl>
      <div class="nav-section" *ngIf="canAccessCmp">
        <button class="nav-button"
                [class.active]="isActive('/cmp/configs')"
                (click)="navigate('/cmp/configs')">
          {{ 'sidebar.nav.cmp' | translate }}
        </button>
      </div>
    </ng-template>

    <!-- Console (embedded admin) Navigation (shared template: classic nav + accordion) -->

  </nav>

  <!-- Bottom Section Toggle -->
  <button type="button"
          class="bottom-section-toggle"
          (click)="toggleBottomSection($event)"
          [attr.aria-expanded]="bottomSectionExpanded">
    <span class="toggle-unread-dot"
          *ngIf="!bottomSectionExpanded && (((unreadCount$ | async) || 0) > 0)"
          aria-hidden="true"></span>
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="3"></circle>
      <path
        d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9A1.65 1.65 0 0 0 10 4.6V4a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V10A1.65 1.65 0 0 0 19.4 11H20a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z">
      </path>
    </svg>
    <span class="chevron" [class.open]="bottomSectionExpanded">▾</span>
  </button>

  <!-- Bottom Section -->
  <div class="sidebar-bottom" [class.collapsed]="!bottomSectionExpanded" (mouseleave)="onBottomSectionMouseLeave()" (mouseenter)="onBottomSectionMouseEnter()">
    <!-- Notification Center -->
    <app-notification-center (newNotification)="openNotifyBroadcastPanel()"></app-notification-center>

    <!-- Documentation Button -->
    <button type="button"
            class="bottom-btn docs-btn"
            (click)="openDocumentation()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      </svg>
      <span>{{ 'sidebar.documentation' | translate }}</span>
    </button>

    <!-- Console: navigazione ESTERNA, non un routerLink. /console e' servito da un altro deploy
         (repo tncid-app-console) che il load balancer raggiunge sullo stesso origin, quindi la
         sessione in localStorage e' condivisa e non serve rifare il login. Prende il posto del
         vecchio pulsante "Admin dashboard", con lo stesso gate di permesso. -->
    <button *ngIf="canAccessAdminPanel"
            type="button"
            class="bottom-btn console-btn"
            (click)="openConsole()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="4" width="18" height="14" rx="2"></rect>
        <line x1="3" y1="9" x2="21" y2="9"></line>
        <line x1="7" y1="14" x2="9" y2="14"></line>
        <line x1="12" y1="14" x2="17" y2="14"></line>
      </svg>
      <span>Console</span>
    </button>

    <!-- Impersonate Account Select (admin only) -->
    <div class="impersonate-select-wrapper" *ngIf="canImpersonate">
      <button type="button"
              class="bottom-btn impersonate-btn"
              #impersonateBtnRef
              [class.impersonating]="!!selectedImpersonateUserId"
              [disabled]="impersonateLoading"
              [attr.aria-expanded]="impersonateDropdownOpen"
              (click)="toggleImpersonateDropdown($event)">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        <span class="impersonate-label">{{ selectedImpersonateUserLabel }}</span>
        <span class="chevron" [class.open]="impersonateDropdownOpen">▾</span>
      </button>

      <!-- Impersonate Dropdown (position:fixed to escape overflow:hidden) -->
      <div class="impersonate-dropdown"
           *ngIf="impersonateDropdownOpen"
           [ngStyle]="impersonateDropdownStyle"
           (click)="$event.stopPropagation()">
        <div class="dropdown-header">{{ 'sidebar.impersonate.title' | translate }}</div>
        <ul class="impersonate-options">
          <li [class.active]="!selectedImpersonateUserId"
              (click)="selectImpersonateFromDropdown('', $event)">
            <span class="option-name">{{ 'sidebar.impersonate.myself' | translate }}</span>
          </li>
          <li class="dcr-separator" aria-hidden="true"></li>
          <li *ngFor="let u of impersonateUsers"
              [class.active]="selectedImpersonateUserId === u.ID"
              (click)="selectImpersonateFromDropdown(u.ID, $event)">
            <span class="option-name">{{ u.name || u.email }}</span>
          </li>
          <li class="dcr-empty" *ngIf="impersonateUsers.length === 0 && !impersonateLoading">
            Nessun utente disponibile
          </li>
        </ul>
      </div>
    </div>

    <!-- User Button -->
    <button type="button"
            class="bottom-btn user-btn"
            (click)="toggleUserMenu($event)"
            [attr.aria-expanded]="userMenuOpen"
            *ngIf="currentUser">
      <div class="user-avatar-small">
        {{ (currentUser.email || currentUser.name || '?').charAt(0).toUpperCase() }}
      </div>
      <div class="user-info">
        <span class="user-email-small">{{ currentUser.email || currentUser.name }}</span>
      </div>
      <span class="chevron" [class.open]="userMenuOpen">▾</span>
    </button>

    <!-- Language Selector -->
    <div class="language-selector-bottom">
      <button class="language-option-bottom"
              type="button"
              [class.active]="currentLanguage === 'it'"
              (click)="changeLanguage('it', $event)"
              title="Italiano">
        <svg width="24" height="16" viewBox="0 0 24 16" aria-hidden="true">
          <rect width="8" height="16" fill="#009246"/>
          <rect x="8" width="8" height="16" fill="#FFFFFF"/>
          <rect x="16" width="8" height="16" fill="#CE2B37"/>
        </svg>
      </button>
      <button class="language-option-bottom"
              type="button"
              [class.active]="currentLanguage === 'en'"
              (click)="changeLanguage('en', $event)"
              title="English">
        <svg width="24" height="16" viewBox="0 0 24 16" aria-hidden="true">
          <rect width="24" height="16" fill="#012169"/>
          <path d="M0 0 L24 16 M24 0 L0 16" stroke="#FFFFFF" stroke-width="3"/>
          <path d="M0 0 L24 16 M24 0 L0 16" stroke="#C8102E" stroke-width="2"/>
          <path d="M12 0 V16 M0 8 H24" stroke="#FFFFFF" stroke-width="5"/>
          <path d="M12 0 V16 M0 8 H24" stroke="#C8102E" stroke-width="3"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- User Dropdown (outside collapsed section to avoid overflow hidden) -->
  <div class="user-dropdown-bottom" *ngIf="userMenuOpen" (click)="onDropdownClick($event)" (mouseenter)="onUserMenuMouseEnter()" (mouseleave)="onUserMenuMouseLeave()">
    <div class="dropdown-header">{{ 'sidebar.userMenu.title' | translate }}</div>
    <button class="dropdown-option" type="button" (click)="requestChangePassword($event)">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>
      {{ 'sidebar.changePassword' | translate }}
    </button>
    <button class="dropdown-option" type="button" *ngIf="canManageExperimentalFeatures" (click)="openExperimentalFeaturesPanel($event)">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M9 2v6l-5.5 9.5A2 2 0 0 0 5.24 21h13.52a2 2 0 0 0 1.74-3.5L15 8V2"></path>
        <path d="M9 2h6"></path>
        <path d="M7.5 14h9"></path>
      </svg>
      {{ 'experimentalFeatures.menuLabel' | translate }}
    </button>
    <button class="dropdown-option logout" type="button" (click)="logout($event)">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <polyline points="16 17 21 12 16 7"></polyline>
        <line x1="21" y1="12" x2="9" y2="12"></line>
      </svg>
      {{ 'sidebar.logout' | translate }}
    </button>
  </div>

  <app-experimental-features-panel
    *ngIf="experimentalFeaturesPanelOpen"
    (close)="closeExperimentalFeaturesPanel()">
  </app-experimental-features-panel>

  <app-notify-broadcast-panel
    *ngIf="notifyBroadcastPanelOpen"
    (close)="closeNotifyBroadcastPanel()">
  </app-notify-broadcast-panel>
</aside>
